module.exports = __webpack_public_path__ + "img/logo.e6425cd9.png";